import styled from "styled-components";

const Essentials = styled.div`
  .mainWrapper {
    position: relative;
    border: 2px solid rgb(0, 162, 242);
    background-color: rgb(255, 255, 255);
    border-radius: 8px;
    padding: 40px;
    background-repeat: no-repeat;
    background-size: auto;
    margin-bottom: 32px;
    margin-top: 16px;
  }
  .tag {
    position: absolute;
    top: 0px;
    transform: translateY(-50%);
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.4px;
    line-height: 16px;
    padding: 6px 8px;
  }
  .subHeading {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.4px;
    line-height: 16px;
  }
  .heading {
    font-size: 20px;
    letter-spacing: 0.15px;
    font-weight: 600;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.83);
    margin-bottom: 16px;
  }
  .description {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: rgb(92, 92, 92);
  }
`;
export default Essentials;
